export const DDialogCloseOn = wcardinal.ui.DDialogCloseOn;